export default __webpack_public_path__ + "static/media/sensenet_logo_transparent.7aafc46d.png";